<template>
  <div style="height: 100%">
    <div v-if="l.plan && l.plan.display">
      <div v-if="!displayFromRow && !img404"
        class="columns is-vcentered is-border-bottom has-bg-light">
        <div class="column is-size-6">
        </div>
        <div class="column is-narrow">
          <a target="_blank" :href="l.plan.path" :download="l.plan.filename"
            class="has-text-grey is-uppercase is-size-6">
            <span class="icon"><i class="fal fa-level-down"></i></span>
            <span>Télécharger le pdf du plan</span>
          </a>
        </div>
      </div>
      <div :class="{'is-padding': !displayFromRow && !img404, 'has-text-centered' : displayFromRow}" >
        <figure class="is-margin-auto" v-if="l.plan.cloudinary_id && !img404" style='background-color: #fbfbfb; border: 1px solid #e1e1e1'>
          <a target="_blank" :href="l.plan.path" :download="l.plan.filename">
            <img v-show="!isLoad" src="static/loading4.svg" alt="" class='background-loading'>
            <img v-show="isLoad" :src="getUrl(l.plan)" @load="loaded" alt="" @error="imageLoadError">
            <img v-show="img404" src="static/plan.png" alt="">
          </a>
        </figure>
        <div v-else-if="img404 && displayFromRow">
          <figure class="is-margin-auto" style='background-color: #fbfbfb; border: 1px solid #e1e1e1'>
            <a target="_blank" :href="l.plan.path" :download="l.plan.filename">
              <img v-show="!isLoad" src="static/loading4.svg" alt="" class='background-loading'>
              <img v-show="img404" src="static/plan.png" alt="" @load="loaded">
            </a>
          </figure>
        </div>
        <div class="column" v-else-if="img404 && !displayFromRow">
          <em><b>Pas de plan disponible</b></em>
        </div>
        <div v-else class="menu">
          <ul class="menu-list">
            <li>
              <a target="_blank" :href="l.plan.path" :download="l.plan.filename">
                <span class="icon"><i class="fal fa-file-pdf"></i></span>
                {{l.plan.filename | truncate}}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else-if="displayFromRow">
      <div class="has-text-centered">
        <figure class="is-margin-auto" style='background-color: #fbfbfb; border: 1px solid #e1e1e1'>
          <a>
            <img v-show="!isLoad" src="static/loading4.svg" alt="" class='background-loading'>
            <img v-show="isLoad" src="static/plan.png" alt="" @load="loaded">
          </a>
        </figure>
      </div>
    </div>
    <div v-else>
      <div class="column">
        <em><b>Pas de plan disponible</b></em>
      </div>
    </div>
  </div>
</template>

<script>
  import cloudinary from 'cloudinary-core'
  const cl = cloudinary.Cloudinary.new({
    cloud_name: 'batiment-b'
  })

  export default {
    name: 'LotPlan',
    data () {
      return {
        isLoad: false,
        img404: false
      }
    },
    props: {
      lot: {
        type: Object,
        required: true
      },
      displayFromRow: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      l () {
        return this.lot
      }
    },
    methods: {
      imageLoadError () {
        this.img404 = true
        this.isLoad = false
      },
      getUrl (plan) {
        return cl.url(plan.cloudinary_id, {height: 650, crop: 'fill', gravity: 'north', quality: 'auto', fetchFormat: 'auto'}) + '.jpg'
      },
      loaded () {
        this.isLoad = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/Tabs/LotPlan.vue